import { Fragment, h } from "preact";
import { memo } from "react";
import { compareRender } from "../../../functions/form";
import { useController, UseControllerProps } from "react-hook-form";
import { Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Text } from "../../text";
import { StyledImageUpload } from "./styled";

interface IItem extends UseControllerProps {
  ref: string;
  id: string;
  format?: string;
  label?: string;
  placeholder?: string;
  accept?: string;
}

interface IImageUpload {
  control?: any;
  item: IItem;
  handleChange?: any;
}

const ImageUpload = ({ control, item, handleChange }: IImageUpload) => {
  const { ref, rules, name, defaultValue, label, accept, placeholder } = item;
  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  });
  const { error } = fieldState;
  const { value } = field;

  return (
    <>
      <Row>
        {label && <Text size={"XS"} text={label} bold={true} />}
        {error && <div />}
      </Row>
      <StyledImageUpload
        id={ref}
        name={ref}
        beforeUpload={() => false}
        accept={accept || "image/*"}
        onChange={(e) => handleChange(e, item)}
        fileList={value}
        listType="picture-card"
      >
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>{placeholder || "Upload"}</div>
        </div>
      </StyledImageUpload>
    </>
  );
};

export const MemoizedImageUpload = memo(ImageUpload, compareRender);
